import { maskedMobilePhone } from '@euler/app/tv/functions/maskedMobilePhone';
import { getCustomerTypeInfo } from '@euler/functions/getCustomerTypes';
import { OrderFieldVisibility } from '@euler/model';
import { CustomerType, OrderReturnType } from '@euler/model/enum';
import { Maybe } from '@euler/types';
import { isNotNull } from '@euler/utils';
import { memo } from 'react';
import {
  OrderSummaryInfoRow,
  OrderSummaryInfoRowProps,
} from './SummaryInfoRow';
import { shouldDisplayField } from './util';

export const CustomerInfoRow = memo(
  ({
    customerName,
    customerType,
    returnType,
    customerMobile,
    defaultVisible,
    customerNameVisibility,
    customerTypeVisibility,
    returnTypeVisibility,
    customerMobileVisibility,
    ...props
  }: {
    customerName?: Maybe<string>;
    customerType?: Maybe<CustomerType>;
    returnType?: Maybe<OrderReturnType>;
    customerMobile?: Maybe<string>;
    customerNameVisibility?: OrderFieldVisibility;
    customerTypeVisibility?: OrderFieldVisibility;
    returnTypeVisibility?: OrderFieldVisibility;
    customerMobileVisibility?: OrderFieldVisibility;
  } & Omit<
    OrderSummaryInfoRowProps<string>,
    'label' | 'value' | 'visibility'
  >) => {
    const isCustomerNameVisible = shouldDisplayField({
      value: customerName,
      visibility: customerNameVisibility,
    });
    const isCustomerTypeVisible = shouldDisplayField({
      value: customerType,
      visibility: customerTypeVisibility,
    });
    const isReturnTypeVisible = shouldDisplayField({
      value: returnType,
      visibility: returnTypeVisibility,
    });
    const isCustomerMobileVisible = shouldDisplayField({
      value: customerMobile,
      visibility: customerMobileVisibility,
    });
    const customerInfo = [
      isCustomerNameVisible ? customerName?.trim() : undefined,
      isCustomerTypeVisible &&
      customerType != null &&
      customerType !== CustomerType.Default
        ? getCustomerTypeInfo(customerType).shortName
        : null,
      isReturnTypeVisible && returnType === OrderReturnType.OnSite
        ? '在厂等待'
        : undefined,
      isCustomerMobileVisible && customerMobile
        ? maskedMobilePhone(customerMobile)
        : undefined,
    ]
      .filter(x => isNotNull(x) && x.length > 0)
      .join('/');

    return (
      <OrderSummaryInfoRow
        label="客户信息"
        value={customerInfo}
        defaultVisible={(defaultVisible ?? true) && customerInfo.length > 0}
        {...props}
      />
    );
  },
);
